import { isBedbankItem } from 'lib/checkout/checkoutUtils'
import { reselectShallowEqual } from 'lib/selector/selectorUtils'
import { createSelector } from 'reselect'
import getBedbankOrderItems from './getBedbankOrderItems'
import { isPostPurchaseAncillaryPayment } from '../payment/isPostPurchaseAncillaryPayment'

const getBedbankItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (state: App.State) => getBedbankOrderItems(state),
  (state: App.State) => isPostPurchaseAncillaryPayment(state),
  (items, bedbankOrderItems, isAncillaryPayment): Array<App.Checkout.BedbankHotelItem> => {
    return isAncillaryPayment ? bedbankOrderItems : items.filter(isBedbankItem)
  },
  reselectShallowEqual,
)

export default getBedbankItems
